import toast from 'react-hot-toast'

export const notify = (message) =>
  toast.success(message, {
    id: message,
    duration: 5000,
    position: 'bottom-center',
    style: {
      backgroundColor: '#ecf2da',
      fontSize: '20px',
      marginBottom: '10%',
    },
  })

export const alert = (message) =>
  toast.error(message, {
    id: message,
    duration: 8000,
    position: 'bottom-center',
    style: {
      backgroundColor: '#f5b0a1ff',
      fontSize: '20px',
      marginBottom: '10%',
    },
  })
